import React from 'react'
import { Badge, ProjectPackage } from '@labsavvyapp/components'
import { ListRow } from '@labsavvyapp/ui-components'
import { calculateOrdersetClientPrice, calculateOrdersetPatientPrice } from '../../../../../utils'
import style from './OrdersetListRow.module.css'
import formatterPrice from '../../../../../../../../utils/formatter-price'

interface OrdersetListRowProps {
  projectPackage: ProjectPackage
  handleOrdersetRowClick: (projectPackage: ProjectPackage) => void
}
export const OrdersetListRow = (props: OrdersetListRowProps) => {
  const projectPackage = props.projectPackage ?? null
  const ordersetId = projectPackage.package?._id ?? null
  const ordersetName = projectPackage.package?.name ?? '--'
  const isOrdersetPrivate = projectPackage.package?.is_private ?? false
  const ordersetPanels = projectPackage.package?.categories[0].panels ?? false
  const ordersetPartnerPrice = formatterPrice(projectPackage.package?.partner_price)
  const ordersetRetailPrice = formatterPrice(projectPackage.package?.retail_price)
  const calculatedOrdersetClientPrice = calculateOrdersetClientPrice(ordersetPanels)
  const calculatedOrdersetPatientPrice = calculateOrdersetPatientPrice(ordersetPanels)

  const handleOrdersetRowClick = () => {
    props.handleOrdersetRowClick(projectPackage)
  }

  return (
    <ListRow key={ordersetId} className={style.row} onClick={handleOrdersetRowClick}>
      <div className={style.column}>{ordersetName}</div>
      <div className={style.column}>{isOrdersetPrivate && <Badge color="pink">Private</Badge>}</div>
      <div className={style.column}>{isOrdersetPrivate ? formatterPrice(calculatedOrdersetClientPrice) : ordersetPartnerPrice}</div>
      <div className={style.column}>{isOrdersetPrivate ? formatterPrice(calculatedOrdersetPatientPrice) : ordersetRetailPrice}</div>
    </ListRow>
  )
}
